import React, { useEffect, useState } from "react";
import CommonService from "../../services/CommonService";
import { useAuth } from "../../context/userContext";
import { toast } from "react-toastify";

const PricingSection = () => {
  const [planType, setPlanType] = useState("Monthly");
  const [initialData, setInitialData] = useState({
    period: "",
  });
  const [razorPaykey, setRazorPaykey] = useState();
  const [paymentResponse, setPaymentResponse] = useState({});
  const { auth } = useAuth();


  // GET RAZOR PAY KEY START
  // GET RAZOR PAY KEY START
  const getRazorpayKey = () => {
    CommonService.get(`${process.env.REACT_APP_API}/payments/razorpay-key`)
      .then((data) => {
        setRazorPaykey(data?.data?.key);
      })
      .catch((err) => toast.error(err?.response?.data?.message));
  };
  useEffect(() => {
    getRazorpayKey();
  }, []);
  // GET RAZOR PAY KEY ENDS
  // GET RAZOR PAY KEY ENDS

  // CREATE PAYEMENT INSTANCE START
  // CREATE PAYEMENT INSTANCE START
  const createPaymetnInstance = () => {
    setInitialData({
      period: planType,
    });
    CommonService.post(`${process.env.REACT_APP_API}/payments/checkout`, {
      membership_period: planType,
      payment_type: "SSB_GPT",
    })
      .then((data) => {
        if (data?.data?.success) {
          // INTILSE RAZOR PAY FOR PAYENT POPUP START
          const intialiseRazorPay = (order) => {
            var options = {
              key: razorPaykey,
              amount: order.amount,
              currency: "INR",
              order_id: order.id,
              handler: function (response) {
                setPaymentResponse(response);
              },
              prefill: {
                name: auth?.user?.first_name,
                email: auth?.user?.email,
                contact: auth?.user?.phone,
              },
            };

            const razor = new window.Razorpay(options);
            razor.open();
          };
          intialiseRazorPay(data?.data?.order);
          // INTILSE RAZOR PAY FOR PAYENT POPUP ENDS
        }
      })
      .catch((err) => console.log(err?.response?.data?.message));
  };
  // CREATE PAYEMENT INSTANCE ENDS
  // CREATE PAYEMENT INSTANCE ENDS

  // IF PAYMENT DONE SUCCESSFULLY THEN VERIFY THE PAYMENT
  // PAYMENT VERIFICATIOn START
  // PAYMENT VERIFICATIOn START
  useEffect(() => {
    if (
      paymentResponse?.razorpay_order_id &&
      paymentResponse?.razorpay_payment_id &&
      paymentResponse?.razorpay_signature &&
      initialData?.period
    ) {
      CommonService.post(
        `${process.env.REACT_APP_API}/payments/payment-verification`,
        {
          razorpay_payment_id: paymentResponse?.razorpay_payment_id,
          razorpay_order_id: paymentResponse?.razorpay_order_id,
          razorpay_signature: paymentResponse?.razorpay_signature,
          membership_period: initialData?.period,
          payment_type: "CDS_GPT",
        }
      )
        .then((data) => {
          console.log("data?.data", data?.data);
        })
        .catch((error) => toast.error(error?.response?.data?.message));
    }
  }, [
    initialData?.period,
    paymentResponse?.razorpay_order_id,
    paymentResponse?.razorpay_payment_id,
    paymentResponse?.razorpay_signature,
  ]);

  // PAYMENT VERIFICATIOn ENDS
  // PAYMENT VERIFICATIOn ENDS

  return (
    <section className="mission_rdy">
      <div className="title">
        <h2>Pricing</h2>
      </div>
      <div className="switch_card_plan">
        <div className="plan-toggle">
          <button
            className={planType === "Monthly" ? "active" : ""}
            onClick={() => setPlanType("Monthly")}
          >
            Monthly
          </button>
          <button
            className={planType === "Yearly" ? "active" : ""}
            onClick={() => setPlanType("Yearly")}
          >
            Yearly
          </button>
        </div>

        <div className="plan-cards custonScroll">
          <div className="plan-card">
            <h3>Platoon Plan</h3>
            <h2>Free</h2>
            <ul>
              <li>
                <span className="checkmark">✓</span>
                <span>1 OIR test/month</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>1 Short Mock Psychology</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>1 Short Mock Interview</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Limited Access to GTO</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Spoken English 10 min/daily</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Limited Group Discussion</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Question Ask</span>
              </li>
            </ul>
            <div className="see_btn">
              <button>Get Started</button>
            </div>
          </div>

          <div className="plan-card">
            <h3>Regiment Plan</h3>
            {planType === "Monthly" ? <h2>₹249/month</h2> : <h2>₹2490/year</h2>}
            <ul>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited OIR Test</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Mock Psychology</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Group Discussion</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited GTO Simulation</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Mock Interview</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Spoken English Practice</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>10% Discount on all Alpha Regiment Courses</span>
              </li>
            </ul>
            <div className="see_btn">
              <button onClick={createPaymetnInstance}>Get Started</button>
            </div>
          </div>

          <div className="plan-card">
            <h3>Brigade Plan</h3>
            <h2>₹**</h2>
            <p>**Talk to Sales for Pricing</p>
            <ul>
              <li>
                <span className="checkmark">✓</span>
                <span>Ideal for Schools</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Under the school's branding</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Train with your data</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Can add multiple Admin</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Psychometric test</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Unlimited Mock Tests</span>
              </li>
              <li>
                <span className="checkmark">✓</span>
                <span>Teacher's Dashboard</span>
              </li>
            </ul>
            <div className="see_btn">
              <button>Talk to Sales</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
